<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('reporting.page_title') }}</slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">

          <div class="block block--select">
            <v-custom-select v-model="PreOrderSheet" v-if="TargetOptions.length"
                                :options="TargetOptions"
                                option-name="TargetName"
                                option-value="TargetId"
                                name="preOrder"
                                search-label="TargetName"
                                track-by="TargetId"
                                :fluid="true"
                                :multiple="false"
                                @change="getSheetData">
                <slot slot="label">{{ $t('reporting.select_sheet') }}</slot>
            </v-custom-select>
          </div>

          <div v-if="PreOrderSheetData">
                <h3>Gegevens orderfiche</h3>
                <div class="block--info o-grid o-grid--third">
                    <div>
                        <p>Merk: {{ PreOrderSheetData.BrandCode }}</p>
                        <p>Collectie: {{ PreOrderSheetData.CollectionName }}</p>
                        <p>Startdatum: {{ PreOrderSheetData.StartDate | moment('DD-MM-YYYY') }}</p>
                        <p>Deadline: {{ PreOrderSheetData.Deadline | moment('DD-MM-YYYY') }}</p>
                    </div>
                    <div>
                        <p>Status: {{ PreOrderSheetData.Status }}</p>
                        <p>Laatste update: {{ PreOrderSheetData.LastUpdate | moment('DD-MM-YYYY') }}</p>
                        <p>Aantal producten: {{ PreOrderSheetData.ProductCount }}</p>
                    </div>
                </div>

                <h3>Rapportage</h3>
                <div class="block block--select">
                  <div class="o-grid o-grid--half">
                      <div>
                          <v-custom-select v-model="selectedSalesman"
                                  :options="Salesmen"
                                  option-name="Name"
                                  option-value="Id"
                                  name="salesman"
                                  search-label="Name"
                                  track-by="Id"
                                  :fluid="true"
                                  :multiple="false"
                                  @change="getSheetStats">
                              <slot slot="label">{{ $t('reporting.select_salesman') }}</slot>
                          </v-custom-select>
                      </div>
                      <div>
                          <v-custom-select v-model="selectedCountry"
                                          :options="Countries"
                                          option-name="content"
                                          option-value="value"
                                          track-by="value"
                                          search-label="content"
                                          name="country"
                                          @change="getSheetStats">
                              <slot slot="label">{{ $t('reporting.select_country') }}</slot>
                          </v-custom-select>
                      </div>
                  </div>
                </div>
                <div class="o-grid o-grid--half u-padding-left u-padding-right" v-if="PreOrderSheetStats">
                    <!-- Actual stats -->
                    <div class="u-padding-top">
                        <p v-for="(stat, index) in PreOrderSheetStats.Statistics" :key="`stat-${index}`">
                            {{ stat.Label }} {{ stat.DisplayValue }}
                        </p>
                    </div>
                    <!-- Chart -->
                    <div>
                        <v-bar-chart
                            :chart-data="{
                            labels: reportLabels,
                            datasets: [
                                {
                                    label: 'Pre-orders',
                                    backgroundColor: '#EF7D01',
                                    data: reportData
                                }
                            ]
                            }"
                            :options="{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                    yAxes: [{
                                        ticks: {
                                            min: 0,
                                            max: 100
                                        }
                                    }]
                                }
                            }"
                        ></v-bar-chart>
                    </div>
                </div>
                <div class="o-grid u-pull-right">
                    <button @click="downloadExport" class="c-button c-button--alpha">{{ $t('reporting.export') }}</button>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VBarChart from '@/components/charts/BarChart'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VCustomSelect,
            VBarChart
        },
        data() {
            return {
                PreOrderSheet: {},
                Salesman: {
                    Id: null
                },
                Country: {
                    value: null
                },
                PreOrderSheetData: null,
                PreOrderSheetStats : null
            }
        },
        created: function () {
            this.$store.dispatch('getTargetOptions');
            this.$store.dispatch('getSalesmen').then(() => {
                this.Salesmen.unshift({
                    Name: '- Alle vertegenwoordigers -',
                    Id: null
                })
            });
            this.$store.dispatch('getAvailableCountryOptions').then(() => {
                this.Countries.unshift({
                    content: '- Alle landen -',
                    value: null
                })
            });
        },
        computed: {
            ...mapGetters({
                TargetOptions: 'TargetOptions',
                Salesmen: 'salesmen',
                Countries: 'AvailableCountryOptions'
            }),
            selectedCountry: {
                get () {
                    let output;
                    if (this.Country){
                        output = this.Countries.find((obj) => {
                            return obj.code === this.Country.code;
                        });
                    }

                    if (output) {
                        this.Country = output;
                    }

                    return output ? output : {};
                },
                set (value) {
                    this.Country = value;
                    return value;
                }
            },
            selectedSalesman: {
                get () {
                    let output;
                    if(this.Salesman){
                        output = this.Salesmen.find((obj) => {
                            return obj.Id === this.Salesman.Id;
                        });
                    }

                    if (output) {
                        this.Salesman = output;
                    }

                    return output ? output : {};
                },
                set (value) {
                    this.Salesman = value;
                    return value;
                }
            },
            reportLabels() {
              return this.PreOrderSheetStats.Statistics.map(result => result.Label);
            },
            reportData() {
              return this.PreOrderSheetStats.Statistics.map(result => result.Value);
            }
        },
        methods: {
            getSheetData () {
                this.$store.dispatch('getSheetBaseData', this.PreOrderSheet.TargetId).then((response) => {
                    this.PreOrderSheetData = response;
                    this.getSheetStats();
                });
            },
            getSheetStats() {
                let salesmanId = this.Salesman ? this.Salesman.Id : "undefined";
                let countryCode = this.Country ? this.Country.code : "undefined";

                this.$store.dispatch('getSheetStats', { sheetId: this.PreOrderSheet.TargetId, salesmanId: salesmanId, country: countryCode })
                           .then((response) => {
                    this.PreOrderSheetStats = response;
                });
            },
            downloadExport() {
                let salesmanId = this.Salesman ? this.Salesman.Id : "undefined";
                let countryCode = this.Country ? this.Country.code : "undefined";
                
                this.$store.dispatch('downloadExport', { sheetId: this.PreOrderSheet.TargetId, salesmanId: salesmanId, country: countryCode }).then((csv) => {

                //Here, data is type of string
                var blob = this.b64toBlob(csv.Content, 'application/octet-stream');
                var fileName = csv.FileName;

                // IE10+ : (has Blob, but not a[download] or URL)
                if (navigator.msSaveBlob) {
                    return navigator.msSaveBlob(blob, fileName);
                } else {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display:none";
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }
                });
            },
            b64toBlob(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }
        }
    }
</script>

<style lang="scss" scoped>
  .block {
    padding: 20px;
    background-color: #f2f2f2;
    margin-bottom: 2em;
  }

  .block--info {
    margin-bottom: 2em;
    p {
      -webkit-margin-before: 0;
      -webkit-margin-after: 0;
      margin-bottom: 0.3em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/reports/PreOrderReport.vue